var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tile-basic',{staticClass:"is-info",attrs:{"title":_vm.action.name,"img":"action","imgSize":"75px","headerImg":"action","link":_vm.actionLink,"values":_vm.keyValues(_vm.action)}})}
var staticRenderFns = []

export { render, staticRenderFns }